import { render, staticRenderFns } from "./IconUnicons.vue?vue&type=template&id=474b3d11&"
import script from "./IconUnicons.vue?vue&type=script&lang=js&"
export * from "./IconUnicons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports